import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ExamWizard } from '../../organisms/ExamWizard';

export function ExamCreateTemplate() {
  const { t } = useTranslation('examManagement');

  return (
    <div className="flex flex-col gap-mini">
      {/** Breadcrumb */}
      <Breadcrumb>
        <BreadcrumbLink href="/">
          <Link to="/">
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>

        <BreadcrumbLink>
          <Link to={'/exams' as never} search={{} as never}>
            {t('breadcrumb.exams')}
          </Link>
        </BreadcrumbLink>

        <BreadcrumbPage>{t('breadcrumb.create')}</BreadcrumbPage>
      </Breadcrumb>

      <h1 className="ts-heading-lg text-ctx-content-title mb-xxs">{t('form.title')}</h1>

      <div className="rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-sm shadow-level1">
        <ExamWizard />
      </div>
    </div>
  );
}
